import { render, staticRenderFns } from "./VesselSelect.vue?vue&type=template&id=38655d80&scoped=true&"
import script from "./VesselSelect.vue?vue&type=script&lang=ts&"
export * from "./VesselSelect.vue?vue&type=script&lang=ts&"
import style0 from "./VesselSelect.vue?vue&type=style&index=0&id=38655d80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38655d80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCheckbox,VList,VListItem,VSelect,VTooltip})
